var loadedImage = {};
var browserImageLoader = function (src, callback) {
    var image = new Image();
    image.src = src;
    image.crossOrigin = '';
    image.onload = function () {
        callback(image);
    };
};
var imageLoader = browserImageLoader;
export function setImageLoader(loader) {
    imageLoader = loader;
}
export function getImageLoader() {
    return imageLoader;
}
export function getImage(src, listernId, callback) {
    var _a;
    if (loadedImage[src]) {
        if (callback && !loadedImage[src].image) {
            loadedImage[src].listeners[listernId] = callback;
        }
        return loadedImage[src].image;
    }
    loadedImage[src] = { image: undefined, listeners: (_a = {}, _a[listernId] = callback, _a) };
    try {
        imageLoader(src, function (image) {
            onImageLoad(loadedImage[src], image);
        });
    }
    catch (err) {
        onImageLoad(loadedImage[src], src);
    }
    return loadedImage[src].image;
}
function onImageLoad(image, res) {
    image.image = res;
    for (var id in image.listeners) {
        var cb = image.listeners[id];
        cb && cb(image.image);
    }
    delete image.listeners;
}
